import { render, staticRenderFns } from "./AddonFeeItem.vue?vue&type=template&id=71ed0dee&"
import script from "./AddonFeeItem.vue?vue&type=script&lang=js&"
export * from "./AddonFeeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports